var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 990,
    height: 719,
    viewBox: "0 0 990 719",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M767.414 10.7509H291.949C282.981 10.7509 275.711 18.0269 275.711 27.0024V372.623C275.711 381.598 282.981 388.874 291.949 388.874H767.414C776.382 388.874 783.652 381.598 783.652 372.623V27.0024C783.652 18.0269 776.382 10.7509 767.414 10.7509Z",
    fill: "#602A84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M783.652 1H308.187C299.219 1 291.949 8.27604 291.949 17.2515V362.872C291.949 371.848 299.219 379.124 308.187 379.124H783.652C792.62 379.124 799.89 371.848 799.89 362.872V17.2515C799.89 8.27604 792.62 1 783.652 1Z",
    fill: "#F6F7FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M783.652 1H308.187C299.219 1 291.949 8.27604 291.949 17.2515V362.872C291.949 371.848 299.219 379.124 308.187 379.124H783.652C792.62 379.124 799.89 371.848 799.89 362.872V17.2515C799.89 8.27604 792.62 1 783.652 1Z",
    stroke: "#602A84",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M520.271 161.207H467.498V249.274H520.271V161.207Z",
    fill: "#807DFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M718.066 118.71H665.293V249.274H718.066V118.71Z",
    fill: "#807DFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M615.8 135.888H563.026V249.274H615.8V135.888Z",
    fill: "#FCBA06"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M449.831 249.274H736.659",
    stroke: "#807DFB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M438.448 86.3529C429.501 67.2899 410.162 54.0936 387.721 54.0936V110.161L438.448 86.3529Z",
    fill: "#FCBA06"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M438.448 86.3529C429.501 67.2899 410.162 54.0936 387.721 54.0936V110.161L438.448 86.3529Z",
    stroke: "#807DFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M387.721 166.229C418.661 166.229 443.742 141.127 443.742 110.161C443.742 79.196 418.661 54.0936 387.721 54.0936C356.781 54.0936 331.7 79.196 331.7 110.161C331.7 141.127 356.781 166.229 387.721 166.229Z",
    stroke: "#807DFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M520.272 40.2799H464.852V48.8119H520.272V40.2799Z",
    fill: "#FCBA06"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M552.748 57.344H464.852V65.876H552.748V57.344Z",
    fill: "#807DFB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M552.748 71.5641H464.852V80.0961H552.748V71.5641Z",
    fill: "#807DFB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M522.919 268.093H467.499V276.625H522.919V268.093Z",
    fill: "#FCBA06"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M555.395 285.158H467.499V293.69H555.395V285.158Z",
    fill: "#807DFB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M522.919 299.378H467.499V307.91H522.919V299.378Z",
    fill: "#807DFB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M659.204 268.093H603.784V276.625H659.204V268.093Z",
    fill: "#FCBA06"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M691.68 285.158H603.784V293.69H691.68V285.158Z",
    fill: "#807DFB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M659.204 299.378H603.784V307.91H659.204V299.378Z",
    fill: "#807DFB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M363.445 181.148H331.7V189.68H363.445V181.148Z",
    fill: "#807DFB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M382.038 198.212H331.7V206.744H382.038V198.212Z",
    fill: "#807DFB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M363.445 223.678H331.7V232.21H363.445V223.678Z",
    fill: "#807DFB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M382.038 240.742H331.7V249.274H382.038V240.742Z",
    fill: "#807DFB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M363.445 266.208H331.7V274.74H363.445V266.208Z",
    fill: "#807DFB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M382.038 283.272H331.7V291.804H382.038V283.272Z",
    fill: "#807DFB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M255.381 612.27C255.381 612.27 171.22 694.064 44.6936 626.49L48.0711 606.046L252.832 593.564L255.381 612.27Z",
    fill: "#EC9F00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4281 549.295L28.8616 718.717H231.43C231.43 718.717 250.169 608.207 240.183 549.295H72.4281Z",
    fill: "#602A84"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M241.336 557.34C241.011 554.577 240.621 551.879 240.183 549.295H72.4282L64.4878 580.173L241.336 557.34Z",
    fill: "#37174D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144.768 718.717L169.32 606.582L184.925 601.658",
    stroke: "#37174D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7245 363.622C87.7245 363.622 68.6449 347.777 73.1103 320.149C77.5758 292.522 98.6851 288.052 98.6851 288.052C98.6851 288.052 73.9222 262.456 102.745 229.141C102.745 229.141 111.676 220.609 122.636 219.39C122.636 219.39 131.567 177.949 178.657 182.418C225.747 186.887 211.328 232.797 198.045 238.892C198.045 238.892 206.018 260.425 193.97 270.988V285.208C193.97 285.208 226.153 293.334 230.213 327.462C234.272 361.59 198.045 373.779 198.045 373.779C198.045 373.779 105.18 381.369 87.7245 363.622Z",
    fill: "#20196F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M126.257 330.761L57.7491 349.256C53.576 350.377 50.1173 353.286 48.2986 357.219C38.8319 377.679 9.08387 443.661 3.28691 477.382C3.28691 477.382 -8.64801 518.58 17.8524 533.921C24.9484 538.033 33.3434 539.301 41.4624 538.13L59.6977 535.481L44.6775 626.49C44.6775 626.49 110.035 635.022 123.026 589.111L131.145 549.295H212.335C212.335 549.295 206.651 595.206 255.365 612.27L241.563 511.104L248.692 472.019L274.705 494.706C282.515 501.516 291.706 506.651 301.725 509.252C317.849 513.428 339.543 512.226 352.387 483.493C374.715 433.52 387.299 367.701 387.299 367.701L357.665 337.229L299.614 422.144L249.195 352.555C247.149 349.743 244.177 347.744 240.8 346.932L174.175 330.778H126.241L126.257 330.761Z",
    fill: "#FCBA06"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M220.194 429.993C217.645 400.789 187.182 349.272 174.192 330.778H126.257C126.257 330.778 150.923 466.559 131.161 549.312H212.351C212.351 549.312 222.045 451.136 220.194 429.993Z",
    fill: "#E9F6FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M219.203 466.786C193.726 474.993 162.354 479.073 138.695 481.104C138.192 505.172 136.032 528.851 131.145 549.295H212.334C212.334 549.295 216.93 502.686 219.187 466.786H219.203Z",
    fill: "#807DFB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M174.192 330.761L172.909 312.592C175.946 312.625 178.966 312.186 181.905 311.211C203.826 303.898 198.127 277.148 194.895 262.456C193.434 255.81 191.453 248.35 188.368 241.606C171.123 248.123 153.488 238.892 153.488 238.892C146.993 252.705 134.815 254.737 134.815 254.737C135.351 265.073 131.908 271.476 129.554 274.596C130.447 277.408 126.257 330.778 126.257 330.778C126.257 330.778 131.291 362.419 133.613 383.384C140.287 383.936 147.156 384.245 154.17 384.245C171.431 384.245 187.816 382.474 202.592 379.321C192.703 359.38 181.028 340.512 174.192 330.778V330.761Z",
    fill: "#FFA189"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M159.253 248.236C159.253 248.236 179.258 254.558 189.407 244.027C189.066 243.215 188.725 242.402 188.367 241.606C171.123 248.123 153.488 238.892 153.488 238.892C146.993 252.705 134.815 254.737 134.815 254.737C134.896 256.427 134.88 258.003 134.766 259.482C141.748 259.694 153.829 258.459 159.237 248.236H159.253Z",
    fill: "#F8756A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M133.028 268.908C137.965 274.271 138.078 282.202 133.288 286.606C128.498 291.01 120.623 290.23 115.686 284.867C110.75 279.504 110.636 271.574 115.426 267.169C120.217 262.765 128.092 263.545 133.028 268.908Z",
    fill: "#FFA189"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M25.614 488.352C25.614 488.352 31.2973 463.569 64.5852 459.506C97.8731 455.443 134.409 458.287 148.617 453.818L151.475 495.259C151.475 495.259 91.5402 533.044 59.7138 535.482L25.614 488.352Z",
    fill: "#FCBA06"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5594 459.213C65.5594 459.213 69.4403 449.479 76.8611 417.837L75.5458 458.563L65.5432 459.23L65.5594 459.213Z",
    fill: "#EC9F00"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M172.909 312.609C172.909 312.609 154.901 311.829 144.752 294.358C144.752 294.358 146.295 316.866 173.737 324.375L172.909 312.609Z",
    fill: "#F8756A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M119.388 271.606L131.161 279.732",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M248.708 472.02C248.708 472.02 255.284 448.146 255.382 429.847C255.447 417.821 243.609 403.032 240.183 388.812",
    stroke: "#EC9F00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M259.847 506.635H175.004L190.43 395.719H275.273L259.847 506.635Z",
    fill: "#807DFB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M148.86 457.263C148.86 457.263 162.224 451.185 166.479 445.708C170.733 440.232 185.315 432.463 185.315 432.463L183.935 444.473C183.935 444.473 228.784 430.464 234.467 432.707C240.15 434.95 229.19 441.645 229.19 441.645C229.19 441.645 239.744 437.843 240.15 440.053C240.556 442.263 236.903 448.146 234.662 449.771C234.662 449.771 237.504 448.959 237.715 451.803C237.926 454.647 223.101 466.624 210.922 471.304C210.922 471.304 224.529 468.46 228.378 471.304C228.378 471.304 208.486 481.25 201.179 483.493C193.872 485.736 151.15 490.595 151.15 490.595L148.844 457.263H148.86Z",
    fill: "#FFA189"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M229.206 441.629L192.459 453.818",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M234.678 449.755C234.678 449.755 209.915 459.506 196.324 463.162",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M210.922 471.288L198.743 474.75",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M148.049 497.372C148.049 497.372 125.12 511.884 98.0842 523.781",
    stroke: "#EC9F00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M25.614 488.352C25.614 488.352 31.2973 463.569 64.5852 459.506C97.873 455.443 134.409 458.287 148.617 453.818",
    stroke: "#EC9F00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M299.63 422.127C299.63 422.127 288.669 432.285 284.204 449.755",
    stroke: "#EC9F00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M148.86 457.263L151.15 490.579L158.83 489.685L148.86 457.263Z",
    fill: "#F8756A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M359.678 339.277L382.493 308.936C382.493 308.936 391.375 298.957 403.797 293.091C418.996 285.924 438.903 272.37 438.903 272.37C438.903 272.37 445.593 276.628 438.903 282.933L420.847 300.404L432.083 308.757C436.549 311.764 436.825 318.492 432.343 321.498C432.116 321.661 431.856 321.807 431.596 321.953C431.596 321.953 434.032 329.266 426.725 332.712C426.725 332.712 426.92 337.993 421.659 340.22C416.398 342.446 407.369 339.001 407.369 339.001C407.369 339.001 405.421 349.873 389.589 352.912L382.606 362.842L359.678 339.277Z",
    fill: "#FFA189"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M398.925 305.474L431.401 302.419C431.401 302.419 434.438 311.357 426.124 313.389C417.81 315.42 409.285 318.67 409.285 318.67C409.285 318.67 410.633 331.477 397.886 334.922L398.941 305.474H398.925Z",
    fill: "#FFA189"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M404.673 304.938L431.401 302.435C431.401 302.435 434.438 311.373 426.124 313.405C417.81 315.436 409.285 318.687 409.285 318.687C409.285 318.687 410.633 331.493 397.886 334.938",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M409.285 318.687C409.285 318.687 425.718 323.968 431.613 321.937",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M407.369 327.771C407.369 327.771 416.998 333.719 426.741 332.695",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M407.369 339.001C407.369 339.001 402.254 335.166 402.725 332.825",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M359.678 339.277L387.997 355.561L382.606 362.842L359.678 339.277Z",
    fill: "#F8756A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M170.019 266.763C170.148 268.502 169.255 269.981 168.021 270.062C166.787 270.143 165.683 268.827 165.553 267.088C165.423 265.349 166.316 263.87 167.55 263.789C168.784 263.691 169.889 265.024 170.019 266.763Z",
    fill: "#20196F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M192.654 264.537C192.784 266.275 191.891 267.754 190.657 267.836C189.423 267.917 188.319 266.6 188.189 264.862C188.059 263.123 188.952 261.644 190.186 261.563C191.42 261.465 192.524 262.798 192.654 264.537Z",
    fill: "#20196F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M158.165 257.857C158.165 257.857 162.63 252.202 169.661 254.948",
    stroke: "#20196F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M183.707 253.42C183.707 253.42 186.646 249.699 191.517 249.764",
    stroke: "#20196F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M177.407 267.007C177.407 273.572 172.73 278.903 166.966 278.903C161.201 278.903 156.525 273.572 156.525 267.007C156.525 260.441 161.201 255.111 166.966 255.111C172.73 255.111 177.407 260.441 177.407 267.007V267.007Z",
    stroke: "#E9F6FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M202.592 264.016C202.592 270.582 198.727 275.913 193.97 275.913C189.212 275.913 185.347 270.582 185.347 264.016C185.347 257.451 189.212 252.12 193.97 252.12C198.727 252.12 202.592 257.451 202.592 264.016V264.016Z",
    stroke: "#E9F6FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M177.309 265.382L185.347 264.016",
    stroke: "#E9F6FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M182.213 266.828C182.213 266.828 190.543 276.286 191.437 280.756C192.33 285.225 183.935 284.624 183.935 284.624",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M172.876 288.67L184.876 290.295C184.876 290.295 184.487 295.707 177.91 294.894C171.35 294.082 172.876 288.67 172.876 288.67Z",
    fill: "#E9F6FF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M121.012 322.051C130.653 322.051 138.468 314.229 138.468 304.58C138.468 294.932 130.653 287.11 121.012 287.11C111.372 287.11 103.556 294.932 103.556 304.58C103.556 314.229 111.372 322.051 121.012 322.051Z",
    stroke: "#E9F6FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M222.792 395.719L221.46 404.527H251.468L252.67 395.719",
    stroke: "#20196F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M134.977 117.964H52.1144C47.0644 117.964 42.9724 122.06 42.9724 127.114V157.602C42.9724 162.656 47.0644 166.751 52.1144 166.751H105.651L122.636 185.879V166.751H134.977C140.027 166.751 144.119 162.656 144.119 157.602V127.114C144.119 122.06 140.027 117.964 134.977 117.964Z",
    fill: "#E9F6FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0062 146.063C74.6786 146.063 76.8451 143.895 76.8451 141.22C76.8451 138.546 74.6786 136.377 72.0062 136.377C69.3337 136.377 67.1672 138.546 67.1672 141.22C67.1672 143.895 69.3337 146.063 72.0062 146.063Z",
    fill: "#602A84"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M100 141.22C100 143.886 97.8407 146.063 95.1614 146.063C92.4822 146.063 90.3225 143.902 90.3225 141.22C90.3225 138.539 92.4822 136.377 95.1614 136.377C97.8407 136.377 100 138.539 100 141.22Z",
    fill: "#602A84"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M121.012 141.22C121.012 143.886 118.853 146.063 116.173 146.063C113.494 146.063 111.334 143.902 111.334 141.22C111.334 138.539 113.494 136.377 116.173 136.377C118.853 136.377 121.012 138.539 121.012 141.22Z",
    fill: "#602A84"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M419.905 511.267L363.364 533.19C363.364 533.19 322.493 548.093 316.81 583.294C311.127 618.511 301.108 674.026 301.108 674.026L225.877 688.376V718.717H565.527L562.718 643.619L604.173 640.791C595.161 583.033 585.013 537.253 523.844 522.627L468.408 508.553L419.905 511.267Z",
    fill: "#602A84"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M407.726 516.272C407.726 516.272 405.177 556.609 444.148 554.577C483.119 552.546 480.878 511.543 480.878 511.543",
    stroke: "#37174D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M365.183 649.242L306.012 646.463C303.202 662.422 301.108 674.026 301.108 674.026L225.877 688.376V718.717H364.826L365.199 649.242H365.183Z",
    fill: "#FFA189"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M306.028 646.463L365.183 649.242V663.673L306.028 646.463Z",
    fill: "#F8756A"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M490.637 415.627C488.007 401.813 474.594 401 474.594 401C476.218 390.437 465.858 382.506 449.831 384.131C433.805 385.756 429.729 377.013 411.477 374.787C393.226 372.56 385.091 390.226 389.361 405.47C393.632 420.713 411.477 422.127 411.477 422.127L412.906 472.702L457.35 473.921C468.895 473.921 478.264 465.145 478.264 454.322C478.264 452.631 478.021 451.006 477.582 449.446C486.497 440.508 492.472 425.166 490.637 415.61V415.627Z",
    fill: "#20196F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M470.34 435.129C464.998 435.129 460.419 438.411 458.519 443.076C454.654 439.516 451.13 433.373 450.854 422.745C450.854 422.745 435.802 429.294 430.151 423.753C424.273 417.967 424.663 410.345 424.663 410.345C424.663 410.345 419.353 421.526 406.525 417.967L401.393 464.934C401.393 464.934 397.22 485.882 421.87 490.432L419.385 516.792C419.385 516.792 417.778 540.65 438.595 541.576C468.911 542.925 468.911 516.792 468.911 516.792L464.527 459.311C466.264 460.205 468.245 460.725 470.34 460.725C477.403 460.725 483.136 454.988 483.136 447.918C483.136 440.849 477.403 435.112 470.34 435.112V435.129Z",
    fill: "#FFA189"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M450.854 422.745C450.854 422.745 435.802 429.294 430.151 423.753C424.273 417.967 424.662 410.345 424.662 410.345C424.662 410.345 419.352 421.526 406.524 417.967C406.524 417.967 414.514 424.013 423.72 421.575C423.72 421.575 429.956 434.3 442.134 432.675C442.134 432.675 449.198 444.766 458.518 443.059C454.654 439.5 451.13 433.357 450.854 422.729V422.745Z",
    fill: "#F8756A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M421.869 490.449C421.869 490.449 443.742 493.845 452.056 473.937C452.056 473.937 450.335 500.005 420.749 502.215L421.853 490.449H421.869Z",
    fill: "#F8756A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M463.228 450.161L476.413 443.254",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M418.281 437.371L409.74 451.299C408.684 453.038 409.448 455.297 411.347 456.028L418.281 458.693",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M413.767 464.999C413.767 464.999 423.64 468.054 429.128 462.155",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M409.934 438.233C411.163 438.233 412.159 436.821 412.159 435.08C412.159 433.339 411.163 431.927 409.934 431.927C408.706 431.927 407.71 433.339 407.71 435.08C407.71 436.821 408.706 438.233 409.934 438.233Z",
    fill: "#20196F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M431.905 441.613C433.133 441.613 434.129 440.201 434.129 438.46C434.129 436.719 433.133 435.307 431.905 435.307C430.676 435.307 429.68 436.719 429.68 438.46C429.68 440.201 430.676 441.613 431.905 441.613Z",
    fill: "#20196F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M428.608 428.53C428.608 428.53 435.509 426.499 439.666 432.788",
    stroke: "#20196F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M404.771 426.792C404.771 426.792 408.766 425.15 413.767 426.792",
    stroke: "#20196F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M364.582 717.092L365.8 608.613",
    stroke: "#37174D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M308.187 634.145L365.491 637.054",
    stroke: "#37174D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M444.554 685.954L406.119 666.729C406.119 666.729 400.159 662.666 392.04 668.89C383.921 675.114 360.1 697.607 349.286 698.679C349.286 698.679 345.226 707.617 357.941 707.617C357.941 707.617 363.088 713.582 373.091 709.243C373.091 709.243 379.586 714.118 388.793 708.43C388.793 708.43 394.752 712.493 404.495 710.055L417.485 705.992C417.485 705.992 426.952 717.368 444.554 718.717H569.863C569.863 718.717 616.417 715.467 610.457 676.463C605.489 643.863 604.19 640.775 604.19 640.775L533.863 645.585L536.201 666.664L444.57 685.938L444.554 685.954Z",
    fill: "#FFA189"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M533.846 645.585L604.173 640.791L606.43 651.696L533.846 645.585Z",
    fill: "#F8756A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M536.185 666.68C536.185 666.68 551.319 664.275 562.88 673.018",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M444.554 685.954L454.702 690.683",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M417.485 705.992L427.699 701.864C427.699 701.864 436.63 713.647 448.191 711.42",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M388.809 708.43L413.507 693.332",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M373.107 709.243L401.15 686.832",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M357.957 707.617L390.157 682.769",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M533.847 645.585L527.368 602.113",
    stroke: "#37174D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M532.142 634.144L601.965 627.124",
    stroke: "#37174D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M416.543 705.862H265.124V718.734H416.543V705.862Z",
    fill: "#84828F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M337.886 718.717H176.351L143.875 591.419H305.41L337.886 718.717Z",
    fill: "#84828F"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M305.411 591.419H294.044L326.52 718.717H337.887L305.411 591.419Z",
    fill: "#84828F"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M236.821 650.672C238.51 657.417 235.636 663.95 230.424 665.25C225.211 666.55 219.609 662.146 217.92 655.385C216.232 648.641 219.106 642.108 224.318 640.808C229.531 639.508 235.133 643.912 236.821 650.672Z",
    fill: "#E9F6FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M749.828 479.869C749.828 479.869 705.58 488.905 677.163 458.027C648.747 427.149 692.184 382.1 692.184 382.1C692.184 382.1 669.044 360.518 680.005 339.797C680.005 339.797 690.836 324.765 710.792 334.516C710.792 334.516 734.126 302.825 773.033 320.702C811.939 338.578 811.533 388.958 810.315 398.173C810.315 398.173 858.331 472.133 749.828 479.885V479.869Z",
    fill: "#20196F"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M708.828 538.066L701.52 559.599L640.628 496.624C640.628 496.624 643.47 485.784 638.062 474.408C632.655 463.032 636.163 450.031 636.163 450.031C636.163 450.031 630.479 447.317 626.696 452.469L620.931 470.671L570.788 457.442C569.863 457.149 568.921 456.987 567.947 456.938C564.618 456.792 557.311 457.084 556.077 462.496C556.077 462.496 546.87 459.441 541.674 467.469L546.87 469.809C546.87 469.809 538.718 470.589 536.819 476.001L543.103 480.86C543.103 480.86 547.471 488.791 551.465 491.472C564.342 500.102 606.95 508.813 613.04 515.72L668.265 609.621C676.173 623.077 686.776 635.201 702.202 637.476C712.546 639.004 728.248 636.111 736.026 625.417C757.558 595.84 768.908 570.162 768.908 570.162L708.828 538.066Z",
    fill: "#FFA189"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M701.521 559.599L720.065 579.231",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M752.898 561.598L744.145 613.765C744.145 613.765 763.095 582.107 768.908 570.162L752.898 561.614V561.598Z",
    fill: "#F8756A"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M556.061 462.496L589.608 473.32",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M546.854 469.809L584.201 481.185",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M541.658 479.869L579.054 490.124",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M598.62 490.124C598.62 490.124 617.294 479.966 624.796 498.249",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M936.029 523.439C936.029 523.439 973.101 527.778 986.643 570.162C1000.17 612.546 955.791 718.733 955.791 718.733H777.709L843.749 599.285L936.029 523.439Z",
    fill: "#20196F"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M873.513 613.765L883.451 621.078L862.487 718.717",
    stroke: "#423EAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M917.047 539.041L928.187 550.043C940.219 561.939 957.042 567.627 973.815 565.466L974.189 565.417",
    stroke: "#423EAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M939.537 718.717C939.537 718.717 979.596 595.108 964.982 565.904",
    stroke: "#423EAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M883.516 426.028C875.9 416.423 865.134 411.223 855.846 408.395C847.159 405.746 838.001 404.949 828.956 405.697L800.978 408.037L763.956 430.594L750.299 437.908C739.891 443.466 731.853 452.713 728.086 463.91C726.982 467.176 725.959 470.882 725.066 475.091C720.194 498.249 708.828 538.066 708.828 538.066L768.908 570.162L783.019 541.186C788.897 542.372 793.671 541.868 793.671 541.868C808.821 550.807 843.733 599.285 843.733 599.285L936.013 523.439C936.013 523.439 899.754 446.521 883.516 426.044V426.028Z",
    fill: "#807DFB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M783.019 541.17C783.019 541.17 767.024 540.975 764.183 527.226C761 511.852 755.528 499.322 755.528 499.322C755.528 499.322 759.393 549.832 752.914 561.598L768.924 570.146L783.035 541.17H783.019Z",
    fill: "#423EAF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M800.978 408.054L771.295 393.314C775.825 391.591 779.057 386.975 779.057 381.547C779.057 374.641 773.828 369.05 767.382 369.05C760.935 369.05 755.706 374.641 755.706 381.547C755.706 381.872 755.723 382.181 755.755 382.49C755.593 382.344 755.43 382.214 755.268 382.067C741.514 380.215 714.543 347.305 714.543 347.289C711.994 350.345 709.915 354.359 709.25 359.559L709.785 373.373L699.507 391.25H708.844C708.844 391.25 708.714 418.341 721.704 424.841C733.022 430.513 743.934 426.71 750.851 421.51L763.988 430.594C763.988 430.594 767.999 463.569 789.108 460.855C815.04 457.523 801.01 408.037 801.01 408.037L800.978 408.054Z",
    fill: "#FFA189"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M751.192 380.832C736.805 374.478 714.527 347.305 714.527 347.289C712.237 350.036 710.338 353.546 709.493 357.999C720.438 365.296 737.52 375.892 751.192 380.832Z",
    fill: "#F8756A"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M750.819 421.51C750.819 421.51 759.165 412.588 762.413 405.437C762.413 405.437 764.767 420.973 761.568 428.937L750.835 421.51H750.819Z",
    fill: "#F8756A"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M763.241 386.715L770.938 374.933",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M719.788 399.375L733.055 393.963C733.055 393.963 735.117 401.147 728.118 403.373C722.435 405.193 719.804 399.375 719.804 399.375H719.788Z",
    fill: "#E9F6FF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M718.261 377.891C719.49 377.891 720.486 376.479 720.486 374.738C720.486 372.997 719.49 371.585 718.261 371.585C717.033 371.585 716.037 372.997 716.037 374.738C716.037 376.479 717.033 377.891 718.261 377.891Z",
    fill: "#20196F"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M714.511 363.102C714.511 363.102 721.412 361.07 725.569 367.36",
    stroke: "#20196F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M831.018 529.94L831.83 552.692L762.413 640.044L714.787 659.155C711.182 660.602 708.162 663.186 706.181 666.517L683.253 705.05C683.253 705.05 690.755 709.113 697.867 703.018L695.025 708.901C695.025 708.901 705.775 711.534 711.068 705.846L708.633 710.526C708.633 710.526 713.91 712.964 722.045 711.128C722.045 711.128 731.967 711.128 735.831 707.276C742.132 700.987 751.663 686.962 751.663 686.962C751.663 686.962 767.284 688.392 773.991 678.641L780.681 668.89L868.22 611.36C881.616 602.551 890.108 587.974 891.164 571.982L893.941 529.94H831.018Z",
    fill: "#FFA189"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M697.867 703.018L714.917 673.554",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M711.052 705.862L726.283 677.211",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M722.045 711.128L736.838 682.704",
    stroke: "#F8756A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M831.018 529.94H893.941L893.177 541.576L831.018 529.94Z",
    fill: "#F8756A"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M762.413 705.862H610.994V718.733H762.413V705.862Z",
    fill: "#84828F"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M683.756 718.717H522.221L489.745 591.419H651.28L683.756 718.717Z",
    fill: "#84828F"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M651.28 591.419H639.913L672.389 718.717H683.756L651.28 591.419Z",
    fill: "#84828F"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M582.691 650.672C584.38 657.417 581.506 663.95 576.293 665.25C571.081 666.55 565.479 662.146 563.79 655.385C562.101 648.641 564.975 642.108 570.188 640.808C575.4 639.507 581.002 643.912 582.691 650.672Z",
    fill: "#E9F6FF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M831.018 529.94L827.365 454.37",
    stroke: "#423EAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M893.941 529.94V484.988",
    stroke: "#423EAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIllustration);
export default __webpack_public_path__ + "static/media/login-illustration.3dc2d487bd460bbe2fa92f7e56afb414.svg";
export { ForwardRef as ReactComponent };